export type OfflinePaymentAttachment = {
	id: number;
	attachmentType: string;
	name: string;
	contentType: string;
};

const model: types.models.InputModel = {
	id: 'id',
	attachmentType: 'type',
	name: 'name',
	contentType: 'contentType',
};

export default model;
